import { IonIcon, IonLabel, IonTabButton } from '@ionic/react';
import { ReactElement, ReactNode } from 'react';
import './flow-item-action.css';

export interface FlowItemBaseActionCommonProps {
  onClick?: () => void;
  disabled?: boolean;
}

interface FlowItemBaseActionProps extends FlowItemBaseActionCommonProps {
  icon: string;
  iconPlaceholder?: ReactNode;
  label?: string;
  color?: string;
}

const FlowItemBaseAction = (props: FlowItemBaseActionProps): ReactElement => {
  const { icon, iconPlaceholder, label, color, onClick, disabled } = props;

  let tabButtonStyle = {};
  if (color) {
    tabButtonStyle = { '--color': color };
  }

  return (
    <div
      className="item-action-button"
      onClick={disabled ? undefined : onClick}
    >
      <IonTabButton style={tabButtonStyle} disabled={disabled}>
        {iconPlaceholder ? iconPlaceholder : <IonIcon icon={icon} />}
        <IonLabel>{label}</IonLabel>
      </IonTabButton>
    </div>
  );
};

export { FlowItemBaseAction };
